var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DBox',{attrs:{"id":'cmp-booking-booking_list-sidewindow-further_event_details',"addButton":false,"addLink":false,"topRightMenu":[
    {
      html: _vm.hint,
      icon: 'Help2.svg',
      value: 'question',
      cardStyle: {
        width: '300px',
      },
    } ]}},[(_vm.booking && _vm.booking.fields)?_vm._l((_vm.booking.fields),function(field,index){return _c('TextField2',{key:("" + (field.custom_data_id)),attrs:{"id":("" + (field.custom_data_id)),"label":field.field_label,"placeholder":field.field_label,"value":field.data,"bb":index == _vm.booking.fields.length - 1 ? 'none' : undefined,"lw":"200px"},on:{"blur":function (ref) {
    var name = ref.name;
    var value = ref.value;

    return _vm.onTextFieldBlur(field, value);
  }}})}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }